export class FetchGpioDevicesAction {
  static readonly type = '[GPIO Devices] Fetch GPIO Devices';
}
